export default {
  name: '',
  email: '',
  password: '',
  timezone: 'EST',
  systemOfUnits: 'metric',
  userRoles: [],
}
